import { preparePhone } from '@/helpers/functions'
import Repository from './Repository'

const action = 'pc-api-users'

export default {
  getList(settings = {}) {
    let params = ''

    for (let key in settings) {
      if (key === 'phone') {
        settings[key] = preparePhone(settings[key])
      }
      params += params ? '&' : '?'
      params += `${key}=${settings[key]}`
    }

    return Repository.get(action + params)
  },
  sendSms(action) {
    return Repository.get(action)
  },
  getItem(id) {
    return Repository.get(`${action}/${id}`)
  },
  postItem(data) {
    return Repository.post(action, data)
  },
  updateItem(id, data) {
    return Repository.put(`${action}/${id}`, data)
  },
  deleteItem(id) {
    return Repository.delete(`${action}/${id}`)
  },
}
